

import React from 'react';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import { Box, TextField } from '@mui/material';






export const InputDePassword = ({ value, placeholder, onChangeInput, size='normal', name }) => {


    const [showPassword, setShowPassword] = React.useState(false);


    const handleClickShowPassword = () => { 
        setShowPassword((show) => !show);
    };


    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    return (

        <Box sx={{width:'100%'}}>
            <TextField required
                label={ placeholder }
                type={showPassword ? 'text' : 'password'}
                placeholder={ placeholder }
                fullWidth
                name={name}
                value={value}
                onChange={ onChangeInput }
                size={ size }
                InputProps={{
                    endAdornment:(
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                            { showPassword 
                                ? <VisibilityOff fontSize={ size === 'small' ? 'small' : 'medium' } /> 
                                : <Visibility fontSize={ size === 'small' ? 'small' : 'medium' } />
                            }
                            </IconButton>
                        </InputAdornment>
                )}}
            />
        </Box>


    )

    
}
